import Vue from 'vue';
import Router from 'vue-router';
import productList from '@/views/product-list';
import product from '@/views/product';
import shopWrapper from '@/views/shopWrapper';
import error from '@/views/error';
import store from '@/store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/shop/',
    routes: [
        {
            path: '/:locale([a-z]{2})',
            component: {
                render(c) {
                    return c('router-view');
                },
            },
            props: true,
            children: [
                {
                    path: '',
                    name: 'home',
                    redirect: (to) => {
                        return { ...to, name: 'shop', params: { ...to.params, service: '' } };
                    },
                },
                {
                    path: ':service',
                    component: shopWrapper,
                    name: 'shop',
                    props: true,
                    children: [
                        {
                            path: '',
                            name: 'service',
                            redirect: (to) => {
                                return { ...to, name: 'product-list', params: { ...to.params, category: 0 } };
                            },
                        },
                        {
                            path: ':category',
                            name: 'product-list',
                            component: productList,
                            props: true,
                        },
                        {
                            path: ':category?/product/:productId',
                            name: 'product',
                            component: product,
                            props: true,
                        },
                    ],
                },
                {
                    path: 'error',
                    name: 'error',
                    component: error,
                },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    const sandboxMode = to.query.sandbox;
    if (sandboxMode === 'true') {
        store.commit('enableSandboxMode');
    }
    next();
});

export default router;
